var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Field',_vm._b({attrs:{"field":_vm.field,"extendErrors":_vm.errors,"store":_vm.store},on:{"error":_vm.error},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},'Field',_vm.$attrs,false)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }